<div class="body-container body-container-notifications">
  <div class="page-main">
    <div class="page-container">
      <div class="form-wrapper">
        <div class="form-content">
          <!-- Subscription Management -->
          <div class="form-section form-notifications-section">
            <div class="form-section-side">
              <div class="section-container">
                <h1 class="label-title">Subscription Management</h1>
                <p class="label-subtitle">Announce and engage with your subscribers throughout their subscription lifecycle.</p>
              </div>
            </div>
            <div class="form-section-container padding nopadding">
              <div class="form-section-body">
                <mat-accordion class="custom-mat-list list-grid-std list-emails">
                  <app-notification-item title="Subscription Statuses"
                    subtitle="From onboarding to churn, keep your subscribers informed about changes made to their subscription status."
                    [_notificationSectionKeyName]="_notificationSectionValues.onBoardingEmails"
                    [isReady]="isOnBoardingEmailsReady"></app-notification-item>

                  <app-notification-item title="Subscription Updates"
                    subtitle="Notify your customers when changes are made to their subscriptions."
                    [_notificationSectionKeyName]="_notificationSectionValues.subscriptionChanges"
                    [isReady]="isSubscriptionChangesReady"></app-notification-item>

                  <app-notification-item title="Subscription Reminders"
                    subtitle="Make sure your subscribers are reminded of periodic events, like upcoming charge, prepaid renewal and more."
                    [_notificationSectionKeyName]="_notificationSectionValues.subscriptionRenewalReminders"
                    [isReady]="isSubscriptionRenewalRemindersReady"></app-notification-item>
                </mat-accordion>
              </div>
            </div>
          </div>
          <!-- Invoices & Payments -->
          <div class="form-section form-notifications-section">
            <div class="form-section-side">
              <div class="section-container">
                <h1 class="label-title">Invoices & Payments</h1>
                <p class="label-subtitle">Keep your customers notified about payment initiations, successful payments, refunds, and more.</p>
              </div>
            </div>
            <div class="form-section-container padding nopadding">
              <div class="form-section-body">
                <mat-accordion class="custom-mat-list list-grid-std list-emails">
                  <!-- <app-notification-item title="Payment Collection"
                    subtitle="Notify your customers about their payment activity."
                    [actionDisabled]="true"
                    [_notificationSectionKeyName]="_notificationSectionValues.paymentsAndCredits"
                    [isReady]="isPaymentsAndCreditsReady"></app-notification-item> -->
                    <app-notification-item title="Invoice Receipts"
                    subtitle="Send customers invoice notifications."
                    [_notificationSectionKeyName]="_notificationSectionValues.invoiceReceipt"
                    [isReady]="isInvoiceReceiptReady"></app-notification-item>
                    <app-notification-item title="Payment Collection"
                    subtitle="Notify your customers about their payment activity."
                    [_notificationSectionKeyName]="_notificationSectionValues.paymentCollect"
                    [isReady]="isPaymentFailuresReady"></app-notification-item>

                </mat-accordion>
              </div>
            </div>
          </div>
          <!-- Customer -->
          <div class="form-section form-notifications-section">
            <div class="form-section-side">
              <div class="section-container">
                <h1 class="label-title">Customer</h1>
                <p class="label-subtitle">Keep your customers updated about their account activity</p>
              </div>
            </div>
            <div class="form-section-container padding nopadding">
              <div class="form-section-body">
                <mat-accordion class="custom-mat-list list-grid-std list-emails">
                  <app-notification-item [isReady]="isCustomerOnBoardingEmailsReady" title="Customer Statuses"
                    subtitle="From onboarding to churn, keep your customers informed about changes made to their account status."
                    [_notificationSectionKeyName]="_notificationSectionValues.customerOnBoardingEmails"></app-notification-item>

                  <app-notification-item [isReady]="isCustomerCustomerPaymentMethodsReady" title="Payment Methods"
                    subtitle="Notify your customers about their payment method activity"
                    [_notificationSectionKeyName]="_notificationSectionValues.customerPaymentMethods"></app-notification-item>
                </mat-accordion>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="page-aside" *appRestriction="'feature_email_notifications|enabled|SCOPE_HIDE'">
    <div class="page-aside-container">
      <div class="form-wrapper">
        <h1 class="provider-header">Notification Channels</h1>
        <mat-list class="mail-providers">
          <mat-list-item class="provider" [routerLink]="['/main/integrations/notification-channels/google']">
            <img class="provider-icon" src="assets/images/gmail.png">
            <div class="provider-title">Gmail</div>
          </mat-list-item>
          <mat-list-item class="provider" [routerLink]="['/main/integrations/notification-channels/smtp']">
            <img class="provider-icon smtp-icon" src="assets/images/smtp.png">
            <div class="provider-title">SMTP</div>
          </mat-list-item>
        </mat-list>
      </div>

      <div class="form-wrapper" *appRestriction="'feature_dailyop_notification|enabled|SCOPE_HIDE'">
        <h1 class="provider-header">Internal Notifications</h1>
        <mat-list class="mail-providers">
          <mat-list-item class="provider" [routerLink]="['/main/integrations/notification-channels/internal']">
            <div class="provider-title">Daily Operations</div>
          </mat-list-item>
        </mat-list>
      </div>
    </div>
  </div>
</div>
